import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { shiftList } from 'api/frequency';
import Edit from '@/views/Attendance/frequency/modal';
export default {
  components: {
    Edit: Edit
  },
  props: {
    p: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      visible: false,
      is_all: true,
      form: {
        is_all: 0,
        name: '',
        shift: {} // 所选班次
      },

      page: {
        page: 1,
        size: 1000000000,
        total: 0
      },
      loading: false,
      tableData: [],
      index: null,
      isMultiple: false,
      selected: [],
      currentShiftId: undefined
    };
  },
  watch: {
    visible: function visible(v) {
      if (!v) {
        this.form.name = '';
        this.form.shift = {};
      }
    }
  },
  methods: {
    handlerCreateSch: function handlerCreateSch() {
      var msg = {
        title: this.$t('1729'),
        type: 1
      };
      this.$refs.edit.init(msg);
    },
    updateCurrentShiftId: function updateCurrentShiftId(shiftId) {
      this.currentShiftId = shiftId;
    },
    updateFormShiftById: function updateFormShiftById(currentShiftId, tableData) {
      if (!currentShiftId) return;
      var item = tableData.find(function (item) {
        return item.id === currentShiftId;
      });
      if (!item) return;
      this.form.shift = item;
    },
    // index要修改的数据 isMultiple是否多选 data 默认选中项
    init: function init(index, isMultiple, data) {
      // 修改单条数据索引
      if (!index && index !== 0) {
        this.index = null;
      } else {
        this.index = index;
      }
      this.isMultiple = isMultiple || false;
      this.visible = true;
      // 已选
      this.selected = data;
      if (this.$p(this.p + '.edit')) this.getShiftList(data);
    },
    // 默认选中
    defaultSelect: function defaultSelect(arr) {
      var _this = this;
      this.tableData.forEach(function (item) {
        arr.forEach(function (params) {
          if (params.shift_id === item.id) {
            _this.$refs.table.toggleRowSelection(item, true);
          }
        });
      });
    },
    // 查询
    handlerQuery: function handlerQuery() {
      this.page.page = 1;
      this.getShiftList();
    },
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.page.page = currentPage;
      this.getShiftList();
    },
    // 表格禁选
    checkSelectable: function checkSelectable(row) {
      // console.log(row)
      return row.id !== '1';
    },
    // 获取数据
    getShiftList: function getShiftList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.loading = true;
              _this2.form.is_all = _this2.is_all ? 0 : 1;
              _context.next = 4;
              return shiftList(_objectSpread(_objectSpread({}, _this2.form), _this2.page));
            case 4:
              res = _context.sent;
              _this2.loading = false;
              _this2.tableData = res.data.result;
              _this2.page.total = res.data.count;
              // 表格回显
              _this2.selected && _this2.$nextTick(function () {
                return _this2.defaultSelect(_this2.selected);
              });
              _this2.updateFormShiftById(_this2.currentShiftId || _this2.form.shift.id, _this2.tableData);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    confirm: function confirm() {
      this.visible = false;
      this.$emit('change', this.isMultiple ? this.form.shift : _objectSpread(_objectSpread({}, this.form.shift), {}, {
        index: this.index
      }));
    },
    handlerSelection: function handlerSelection(params) {
      this.form.shift = params;
    }
  }
};